import React from 'react';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

const FooterCopyright = () => {
    const year = new Date().getFullYear();

    return (
        <Row>
            <Col>
                <p>
                    © {year} Copyright Foremost Insurance Company
                </p>
                <Row>
                    <Col className="col-auto mr-auto">
                        <a href="https://www.farmers.com/privacy-center/" className="ml-link" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                    </Col>
                    <Col>
                        <a href="https://www.farmers.com/privacy-statement/#donotsell" className="ml-link" target="_blank" rel="noopener noreferrer">Do Not Sell or Share My Personal Information</a>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default FooterCopyright;
